function AlertBar() {
	const alertContainer = document.getElementById('e29-alert-bar');
	const alertCookie = getCookie('alert') ? true : false;
	let alertClose = null;

	if (alertContainer) {
		alertClose = alertContainer.querySelector('.alert-bar__close');
	}

	function getCookie(cName) {
		const name = cName + '=';
		const cDecoded = decodeURIComponent(document.cookie);
		const cArr = cDecoded.split('; ');
		let res;
		cArr.forEach((val) => {
			if (val.indexOf(name) === 0) res = val.substring(name.length);
		});
		return res;
	}

	function fade(element) {
		let op = 1;
		const alertBar = document.getElementById('e29-alert-bar');

		const timer = setInterval(function () {
			if (op <= 0.1) {
				clearInterval(timer);
				element.style.display = 'none';
			}
			
			element.style.opacity = op;
			element.style.filter = 'alpha(opacity=' + op * 100 + ')';
			op -= op * 0.1;

			const alertBarHeight = alertBar.offsetHeight;
			document.body.style.setProperty('--alert-bar-height', `${alertBarHeight}px`);
		}, 10);
	}

	if (alertContainer) {
		if (alertCookie) {
			alertContainer.style.display = 'none';
		} else {
			alertContainer.style.display = 'block';
		}
	}

	//Close alert item and set local storage
	if (alertClose) {
		alertClose.addEventListener('click', function(e) {
			e.preventDefault();

			document.cookie = 'alert=true; path=/; max-age=86400';
			fade(alertContainer);
			alertContainer.style.display = 'none';
		});
	}
}

// clear search input feild
const input = document.querySelector('.clear-input');
const clearButton = document.querySelector('.clear-input-button');

const handleInputChange = (e) => {
	if (e.target.value && !input.classList.contains('clear-input--touched')) {
		input.classList.add('clear-input--touched');
	} else if (
		!e.target.value &&
		input.classList.contains('clear-input--touched')
	) {
		input.classList.remove('clear-input--touched');
	}
};

// eslint-disable-next-line no-unused-vars
const handleButtonClick = (e) => {
	input.value = '';
	input.focus();
	input.classList.remove('clear-input--touched');
};
if (clearButton !== null) {	
	clearButton.addEventListener('click', handleButtonClick);
}
if (input !== null) {
	input.addEventListener('input', handleInputChange);
}

export default AlertBar;
